import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {CheckpointResult} from '../classes/checkpoint-result';
import {RealtimeService} from './realtime/realtime.service';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';
import {CheckpointResultContent} from '../classes/checkpoint-result-content';
import {CheckpointComment} from '../classes/checkpoint-comment';

@Injectable({
    providedIn: 'root'
})
export class CheckpointCommentService extends RealtimeService<CheckpointComment> {

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.checkpoint_results);
    }

    getCheckpointComment(id: number) {
        return this.apiService.getCallData$<CheckpointComment>(`checkpoints/comments/show/${id}`);
    }

    getCheckpointComments(checkpointId: number) {
        return this.apiService.getCallData$<CheckpointComment[]>(`checkpoints/comments/${checkpointId}`);
    }

    saveCheckpointComment(checkpointComment: CheckpointComment) {
        return this.apiService.postCall$<CheckpointComment>(`checkpoints/comments`, checkpointComment);
    }

    deleteCheckpointComment(id: number) {
        return this.apiService.deleteCall(`checkpoints/comments/${id}`);
    }

    itemInDaterange(planning: CheckpointComment, fromDate: Date, toDate: Date) {
        return true;
    }
}
